// Define benchmark standards for clear performance goals
export const benchmarks = {
  responseTime: {
    excellent: 200,  // ms
    good: 500,       // ms
    acceptable: 1000 // ms
  },
  successRate: {
    excellent: 99,  // %
    good: 95,       // %
    acceptable: 90  // %
  },
  throughput: {
    typical: 20,     // clicks/sec
    high: 50,        // clicks/sec
    stress: 100      // clicks/sec
  },
  batchProcessing: {
    excellentTime: 100 // ms
  }
};

// Default batch sizes for test suite
export const DEFAULT_BATCH_SIZES = [1, 3, 5, 10, 20, 30];

// Default batch intervals for test suite
export const DEFAULT_BATCH_INTERVALS = [50, 100, 200, 500, 800];

// Default test suite all options
export const ALL_TEST_OPTIONS = {
  selectedBatchSizes: DEFAULT_BATCH_SIZES,
  selectedIntervals: DEFAULT_BATCH_INTERVALS
}; 